/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react";
import DateFnsUtils from "@date-io/date-fns";
import {Box, Grid, Icon, IconButton, ThemeProvider} from "@material-ui/core";
import {Calendar as MuiCalendar, MuiPickersUtilsProvider} from "@material-ui/pickers";
import {createMuiTheme, responsiveFontSizes } from "@material-ui/core";
import {useSelector} from "react-redux";
import {RootState} from "../../redux/store";
import {colorError, colorInputBorder, colorPrimary} from "../../Constants/theme";
import moment from "moment/moment";

const Calendar = ({handleChange, value }) => {
    const [selectedDate, setSelectedDate] = useState(value);
    const branding = useSelector((state: RootState) => state?.branding);
    const preferencesOn = useSelector((state: RootState) => state?.branding.partnerPreferencesOn);
    let materialTheme = createMuiTheme({
        typography: {
            allVariants: {
                fontWeight: 700,
                fontFamily: preferencesOn? branding.textFont : "DMSans",
            },
            body1: {
                fontFamily: preferencesOn? branding.headerFont : "Merriweather",
                fontSize: '1.8rem',
            },
            body2: {
                fontSize: '1.2rem',
            },
            caption: {
                fontSize: '1.2rem',
            },
        },
        overrides: {
            // @ts-ignore
            MuiPickersCalendarHeader: {
                daysHeader: {
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    padding: 17,
                    "@media (max-width: 600px)": {
                        padding: 0,
                    }
                },
                switchHeader: {
                    color: preferencesOn? branding.brandHeader : colorPrimary,
                },
                iconButton: {
                    backgroundColor: "transparent",
                    "& svg": {
                        width: "3em",
                        height: "3.5em"
                    },
                    "@media (max-width: 700px)": {
                        "& svg": {
                            width: "2em",
                            height: "2.5em"
                        },
                    }
                },
                dayLabel: {
                    color: preferencesOn? branding.brandHeader : colorPrimary,
                },
                transitionContainer: {
                    height: 50,
                    "@media (max-width: 1135px) and (min-width: 600px)": {
                        height: 100,
                    },
                }
            },
            MuiPickersCalendar: {
                transitionContainer: {
                    border: `1px solid ${colorInputBorder}`,
                    borderRadius: 6,
                    "&>div": {
                        padding: "0 17px",
                    },
                    "@media (max-width: 700px)": {
                        "&>div": {
                            padding: 0,
                        },
                    }
                },
                week: {
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between"
                }
            },
            MuiPickersDay: {
                day: {
                    color: preferencesOn? branding.brandHeader : "#000000",
                },
                daySelected: {
                    backgroundColor: preferencesOn? branding.brandAccent : colorError,
                    color: preferencesOn? branding.buttonText : "#000000",
                    "&:hover": {
                        backgroundColor: preferencesOn? branding.brandAccent : colorError,
                    }
                },
                current: {
                    color: preferencesOn? branding.brandAccent : colorError
                },
            },
            MuiSvgIcon: {
                root: {
                    color: preferencesOn? branding.brandAccent : colorError,
                }
            }
        },
    });
    materialTheme = responsiveFontSizes(materialTheme, {
        breakpoints: ["xs", "sm", "md"],
        factor: 5
    });
    const handleDayChange = (day) => {
        handleChange(day);
        setSelectedDate(day);
    };

    useEffect(() => {
        if(value.toString() === "Invalid Date"){
            setSelectedDate(new Date());
        } else {
            setSelectedDate(value);
        }
    }, []);

    return(
        <ThemeProvider theme={materialTheme}>
            <Grid container justify="center" style={{marginBottom: 40}}>
                <Grid item xs={11} sm={6} md={5} style={{overflow: "hidden"}}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <MuiCalendar
                            date={selectedDate}
                            onChange={(val) => handleDayChange(val)}
                            disablePast
                        />
                    </MuiPickersUtilsProvider>
                </Grid>
            </Grid>
        </ThemeProvider>
    );
};



export default Calendar;
